import store from '../Redux/Store/store';
import { AddAnimationPayloadInterface } from '../Redux/Actions/Animator/animation.list.action';

const checkAnimationRepeatedName = (animation: AddAnimationPayloadInterface, animationList? : Array<AddAnimationPayloadInterface>) => {
    const animationData = animationList ? animationList : store.getState().AnimationList.animations;
    return animationData.find(compAnimation => animation.name === compAnimation.name && animation.id !== compAnimation.id);
}

export default checkAnimationRepeatedName;